export default __webpack_public_path__ + "static/media/outcess-logo.fab9f9cc.png";